import * as React from "react";
const SvgImport = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Import">
    <path
      fill="currentColor"
      d="M202.61 183.81v22.25c0 4.14-3.36 7.5-7.5 7.5H61.53c-4.14 0-7.5-3.36-7.5-7.5v-22.25c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v29.24c0 8.56 6.94 15.5 15.5 15.5H202.1c8.56 0 15.5-6.94 15.5-15.5v-29.24c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5Z"
    />
    <path
      fill="currentColor"
      d="M197.39 100.26a7.5 7.5 0 0 0-10.61 0l-50.95 50.96V50.33c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v100.91l-50.97-50.97a7.502 7.502 0 1 0-10.61 10.61l63.77 63.77a7.5 7.5 0 0 0 10.61 0l63.77-63.77a7.5 7.5 0 0 0 0-10.61Z"
    />
  </svg>
);
export default SvgImport;
